<template>
  <!-- for new record set :create-mode="true" -->
  <record-edit-activity
      :save-enabled="formValid"
      :edit-enabled="true"
      :delete-enabled="true"
      :read-only-mode="readOnlyMode"
      :create-mode="createMode"
      :errorMessage="errorMessage"
      :fluid-bottom-line="false"

      @delete="deleteClick"
      @edit="edit"
      @save="save"
  >

    <!-- HEADER - only in EDIT mode -->
    <!-- Left side button - primary actions -->
    <template v-slot:primaryButton>
      <!-- Extra primary button  -->
    </template>

    <!-- toolbars -->
    <template v-slot:toolButtons>
      <!-- Extra tool buttons -->
    </template>

    <!-- danger actions on the right -->
    <template v-slot:dangerButton>
      <!-- Extra danger buttons -->
    </template>
    <!-- HEADER END-->
    <!-- CONTENT -->

    <b-container class="pt-1 px-2" >
      <b-row no-gutters>
        <b-col>
          <span v-if="readOnlyMode" v-text="formValue"></span>
          <b-input v-else v-model="formValue" ref="firstInput"></b-input>
        </b-col>
      </b-row>
    </b-container>
    <!-- CONTENT END-->

    <template v-slot:bottomLine>
        {{$tr('someBottom','Some stuff on the bottom')}}
    </template>

    <template v-slot:footer>
      <!-- extra footer buttons -->
    </template>
  </record-edit-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import RecordEditActivity from "@/activity/templates/layouts/RecordEditActivity";
import ReachInput from "@/components/inputs/ReachInput";



export default {
  name: "RecordEditActivityTemplate",
  components: {ReachInput, RecordEditActivity, SimpleActivity, FooterButton },
  permission: Perms.SUPERUSER,

  created() {
    if(!this.readOnlyMode) {
      setTimeout(() => {
        this.$refs.firstInput.focus();
      });
    }
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return $tr('simpleActivity','Simple Activity');
    },
    async canClose(){
      return await DialogManager.canClose(this.unsavedChanges || !this.readOnlyMode);
    },

    edit(){
      this.readOnlyMode=false;
      setTimeout(() => {
        this.$refs.firstInput.focus();
      });
    },
    async save(autoClose){
      await DialogManager.info($tr('saveClicked','Save clicked'), $tr('recordSaved','Record saved'));
      let result = "Lol such result";
      this.setResult(result);
      this.$emit("saved", result);

      this.readOnlyMode = true;
      if(autoClose){
        this.close();
      }
    },

    async deleteClick(){
      let confirmed = await DialogManager.yesNo($tr('deletingX','Deleting XXXXX'),
          $tr('recordEditActivityTemplate.sure.delete.Y','Are you sure, do you want to delete YYYYY?'), false);
      if(!confirmed){
        this.errorMessage = "Wow such error!";
        return;
      }
      await DialogManager.info($tr('deleteClicked','Delete clicked'),
          $tr('deleteButtonWasClicked','A Delete button was clicked'));
      this.close();
    },

  },
  props:{
    openInReadOnlyMode: {type:Boolean, default: true},
    // itemId
    createMode:  {type:Boolean, default: false}
  },
  data:function(){return {
    readOnlyMode: this.openInReadOnlyMode && !this.createMode,
    unsavedChanges: false,
    permissions: new PermissionsSet(),
    formValid: true, // should be a real valid status
    formValue: "",
    errorMessage: ""
  }}
}
</script>
